module.exports = __webpack_public_path__ + "img/kid7.ae808089.png";